var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls_icon_Shift-Day",
    "data-name": "Controls/icon/Shift-Day",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2320",
    "data-name": "Rectangle 2320",
    width: 38,
    height: 38,
    fill: "none",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2900",
    "data-name": "Group 2900",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3775",
    "data-name": "Path 3775",
    d: "M39.08,31.777a13.026,13.026,0,0,0,.832-3.07l5.041-1.836-5.019-1.827a12.99,12.99,0,0,0-.8-3.075l3.445-4.106-5.266.928a13.191,13.191,0,0,0-2.229-2.257l.931-5.284-4.086,3.428a12.973,12.973,0,0,0-3.07-.831L27.02,8.8l-1.828,5.02a12.96,12.96,0,0,0-3.075.8l-4.106-3.445.928,5.266a13.222,13.222,0,0,0-2.257,2.229L11.4,17.747l3.428,4.086a13.025,13.025,0,0,0-.831,3.07L8.953,26.738l5.019,1.828a13,13,0,0,0,.8,3.075l-3.445,4.106,5.267-.928a13.15,13.15,0,0,0,2.228,2.257l-.931,5.284,4.086-3.428a12.977,12.977,0,0,0,3.069.831L26.886,44.8l1.828-5.019a13.042,13.042,0,0,0,3.075-.8L35.9,42.427l-.928-5.267a13.217,13.217,0,0,0,2.257-2.228l5.284.93ZM26.953,37.784A10.98,10.98,0,1,1,37.932,26.8,10.993,10.993,0,0,1,26.953,37.784Z",
    transform: "translate(-8.953 -8.804)",
    fill: "#75787b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDay);
export default __webpack_public_path__ + "static/media/Day.55afd94a4db8b4b2676fd6add9dbba41.svg";
export { ForwardRef as ReactComponent };